<template>
  <div class="pc_page_bottom_component">
    <div class="provider" @click="openRq()">本服务由<span>惠民殡服</span>平台提供</div>
    <div class="other_provicer">
      <div class="other_row">
        <div class="item">
          <div>指导单位:</div>
          <div>贵州省殡葬协会数字殡葬专家委员会</div>
          <div>中国殡葬协会互联网+工作委员会</div>
          <div>贵州省民政学会</div>
        </div>
        <div class="item">
          <div>建设单位：</div>
          <div>贵州万福惠民科技发展有限公司</div>
        </div>
        <div class="item setItemt">
          <div >Copyright © 万福惠民科技 2022 All Rights Reserved.</div>
          <div ><a class="setColor" href="https://beian.miit.gov.cn/#/Integrated/index">黔ICP备2021011028号-1</a></div>
          <div class="police_row">
            <img src="@/assets/imgs/pc/police.png" alt="" />
            <a class="setColor" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52011502002196"><span>贵公网安备 52011502002196号</span></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {
    openRq(){
      console.log("=========>>>>*****");
       this.$emit('openRq')
    },
  },
}
</script>
<style scoped lang="scss">
.pc_page_bottom_component {
  background: #f5f5f5;
  .provider {
    text-align: center;
    color: #222222;
    font-size: scal(15);
    padding: scal(30) 0;
    span {
      color: #008e59;
      cursor: pointer;
    }
  }
  .other_provicer {
    border-top: 1px solid #a8a8a8;
    padding: scal(20) 0;
    text-align: left;
    .other_row {
      width: calc(100% - scal(138));
      margin-left: scal(69);
      display: flex;
      justify-content: space-between;
      .item {
        font-size: scal(12);
        color: #8e8e93;
        .police_row {
          display: flex;
          align-items: center;
          img {
            width: scal(16);
            height: scal(16);
          }
        }
      }
    }
    .setItemt:hover{
      cursor:pointer;
    }
    .addunderline{
      text-decoration:underline;
    }
  }
}
.setColor{
  color: #8e8e93;
}
</style>
